import { render, staticRenderFns } from "./ActivitiesNew.vue?vue&type=template&id=4f9dd66c"
import script from "./ActivitiesNew.vue?vue&type=script&lang=ts"
export * from "./ActivitiesNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f9dd66c')) {
      api.createRecord('4f9dd66c', component.options)
    } else {
      api.reload('4f9dd66c', component.options)
    }
    module.hot.accept("./ActivitiesNew.vue?vue&type=template&id=4f9dd66c", function () {
      api.rerender('4f9dd66c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/project/ActivitiesNew.vue"
export default component.exports